import script from "./ProjectCreateView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCreateView.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCreateView.vue?vue&type=style&index=0&id=50822238&lang=scss"

const __exports__ = script;

export default __exports__